import $axios from "../axios";

function revealPriceListApi(params, callback) {
  $axios
    .post("/api/reveal/priceList", params.params)
    .then(res => {
      callback(res);
    })
    .catch(err => {
      console.log(err);
    });
}

function checkPropertyRevealedByUserApi(params, callback) {
  $axios
    .post("/api/check/revealedPriceList/byUser", params.params)
    .then(res => {
      callback(res);
    })
    .catch(err => {
      console.log(err);
    });
}

export default {
  revealPriceListApi,
  checkPropertyRevealedByUserApi
}



// WEBPACK FOOTER //
// ./src/api/revealPriceList/revealPriceList.js